shadow$provide[497] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, queue:{enumerable:true, get:function() {
  return queue;
}}});
const queue = function(limit) {
  if (limit == null) {
    limit = 100;
  }
  const map = {};
  let head = null;
  let tail = null;
  let count = 0;
  const add = function(item) {
    item.prev = null;
    item.next = head;
    if (head != null) {
      head.prev = item;
    }
    head = item;
    if (tail == null) {
      return tail = item;
    }
  };
  const remove = function(item) {
    const {prev} = item;
    const {next} = item;
    if (prev != null) {
      prev.next = next;
    }
    if (next != null) {
      next.prev = prev;
    }
    if (head === item) {
      head = next;
    }
    if (tail === item) {
      return tail = prev;
    }
  };
  return function(key) {
    let dead, item;
    if ((item = map[key]) && item !== head) {
      remove(item);
      add(item);
    } else {
      if (count === limit) {
        dead = tail.key;
        remove(tail);
        delete map[dead];
      } else {
        count++;
      }
      item = {next:head, prev:null, key};
      add(item);
      map[key] = item;
    }
    return dead;
  };
};

};